import { useContext, useEffect, useState } from 'react'
import { Position } from 'types'
import { MediaSprite } from '../../../../types'
import { ArtboardContext } from '../../board/context'

const useImagePosition = (sprite?: MediaSprite, defaultPosition?: Position): Position | undefined => {
    const board = useContext(ArtboardContext)
    const [position, setPosition] = useState<Position>()

    useEffect(() => {
        if (defaultPosition) {
            setPosition(defaultPosition)
            return
        }

        if (!sprite) {
            setPosition(undefined)
            return
        }

        const { crop } = board
        const aspectRatio = sprite.frameWidth / sprite.frameHeight
        const maxWidth = crop ? crop.width : board.width
        const maxHeight = crop ? crop.height : board.height

        let width = Math.min(sprite.frameWidth, maxWidth)
        let height = Math.round(width / aspectRatio)

        if (height > maxHeight) {
            height = maxHeight
            width = Math.round(height * aspectRatio)
        }

        setPosition({
            x: Math.round(maxWidth / 2) + (crop?.x || 0),
            y: Math.round(maxHeight / 2) + (crop?.y || 0),
            rotation: 0,
            width,
            height,
        })
    }, [sprite])

    return position
}

export default useImagePosition
